import { type PaginationState } from '@tanstack/react-table'
import { useState } from 'react'

import CardsTable from './CardsTable'

type CardsMembersViewProps = {
  memberId: string
}

const CardsMembersView = ({
  memberId,
}: CardsMembersViewProps) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 1,
    pageSize: 10,
  })

  return (
    <div className='flex-col w-full h-full space-y-4 bg-white rounded-lg max-w-[2000px] mx-auto'>
      <div className='flex items-center justify-between w-full mb-4 gap-x-2'>
        <div className='heading-md'>Cards</div>
      </div>
      <CardsTable
        memberId={memberId}
        pagination={pagination}
        setPagination={setPagination}
      />
    </div>
  )
}

export default CardsMembersView
